import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '../../common/inputs/inputs.module';
import {
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { DialogService } from '../../../core/services/dialog.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { LingRegExps } from '../../../core/data/ling-reg-exps';
import { LingValidators } from '../../../core/validators/ling-validators';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogParams } from '../../../core/models/dialog-params';
import { AuthService } from '../../../core/services/api/auth.service';
import { SnackBarService } from '../../../core/services/snack-bar.service';
import { LocalStorageKey, QueryParamsKeys } from '../../../core/enums';
import { TranslateModule } from '@ngx-translate/core';
import { navigateToLoginWithNext } from '../../../core/utils';

@Component({
  selector: 'ling-sign-up-dialog',
  standalone: true,
  imports: [
    CommonModule,
    InputsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatButtonModule,
    RouterModule,
    TranslateModule,
  ],
  templateUrl: './sign-up-dialog.component.html',
  styleUrls: ['./sign-up-dialog.component.scss'],
})
export class SignUpDialogComponent implements OnInit {
  isSubmit = false;

  signUpForm = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.pattern(LingRegExps.email)]],
    password: ['', [Validators.required]],
    confirmPassword: [
      '',
      [Validators.required, LingValidators.sameAs('password')],
    ],
    acceptPolicy: [false, [Validators.requiredTrue]],
  });

  constructor(
    private fb: NonNullableFormBuilder,
    private auth: AuthService,
    private dialog: DialogService,
    private message: SnackBarService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public dialogParams: DialogParams
  ) {}

  ngOnInit() {
    if (this.dialogParams.data) {
      this.signUpForm.patchValue(this.dialogParams.data);
    }
  }

  onContinue(): void {
    this.isSubmit = true;

    if (this.signUpForm.invalid) {
      this.message.required();
      return;
    }
    const { name, email, password } = this.signUpForm.getRawValue();
    this.auth.registerUser({ name, email, password }).subscribe({
      next: () => {
        this.dialog.closeCurrent({ name, email, password });
        const nextLocation = this.router.url;
        localStorage.setItem(LocalStorageKey.NextLocation, nextLocation);
        navigateToLoginWithNext(this.router, this.route, this.router.url, {
          [QueryParamsKeys.UnverifiedLogin]: true,
        });
      },
      error: (err) => {
        if (err.code === 405) {
          this.dialog.openNotInWhiteListDialog();
        }
        if (err.code === 409) {
          this.dialog.openAccountAlreadyExistsDialog(email);
        }
      },
    });
  }
}
